
import { Component, Vue, Prop } from "vue-property-decorator";
import SavePanel from "../../Base/SavePanel.vue";
import Map from "../../Base/Map.vue";
import AutoAssignBox from "../../Base/AutoAssignBox.vue";
import { City } from "@/models/City";
import { Game } from "@/models/Game";
import ComposeQuestTable from "../ComposeQuestMapTable.vue";
import { MapOptions } from "@/models/Map";
import EditPoiVertical from "../EditQuestPoi.vue";
import { ActionRefData, QuestMapPoi } from "@/models/MapPois/Quest/QuestMapPoi";
import DateHelper from "@/utils/DateHelper";

@Component({
  components: {
    SavePanel,
    Map,
    EditPoiVertical,
    ComposeQuestTable,
    AutoAssignBox,
  },
})
class ComposeMap extends Vue {
  @Prop({ default: null }) readonly gameData!: Game;
  @Prop({ default: false }) readonly isEditingLocked!: boolean;
  showSavePanel = false;
  showEditPoiPanel = false;
  mapPoiKey = "";
  showAutoAssign = false;

  get getCityData(): City {
    return this.$store.state.cityStore.singleCity;
  }
  get getMapPoiData(): QuestMapPoi[] {
    return this.$store.state.mapPoiStore.questMapPoi;
  }
  get getHiddenCount(): number {
    return this.getMapPoiData.filter((x) => x.visible == false).length;
  }

  get getMapLocation(): MapOptions[] {
    var arr = [];
    for (var i = 0; i < this.getMapPoiData.length; i++) {
      if (
        this.getCityData.locations[this.getMapPoiData[i].loc.loc_uid] !==
        undefined
      ) {
        var val = this.getCityData.locations[this.getMapPoiData[i].loc.loc_uid];
        var locationMarker: MapOptions = {
          position: {
            lat: val.lat_long.latitude,
            lng: val.lat_long.longitude,
          },
          title: this.getMapPoiData[i].title.en,
          draggable: false,
          clickable: true,
          slug: this.getMapPoiData[i].key,
          radius: this.getMapPoiData[i].loc.geo_rad_m,
          color:
            this.getMapPoiData[i].key === "START_ZONE" ? "#2499DB" : "#E06B6B",
          zIndex: 100,
          icon: DateHelper.getMapQuestImage(this.getMapPoiData[i]),
          //path: this.getPoiMapPath(this.getMapPoiData[i], true),
        };
        arr.push(locationMarker);
      } else {
        var locationMarker2: MapOptions = {
          position: {
            lat: this.getMapPoiData[i].loc.override_ll.latitude,
            lng: this.getMapPoiData[i].loc.override_ll.longitude,
          },
          title: this.getMapPoiData[i].title.en,
          draggable: false,
          clickable: true,
          slug: this.getMapPoiData[i].key,
          radius: this.getMapPoiData[i].loc.geo_rad_m,
          color:
            this.getMapPoiData[i].key === "START_ZONE" ? "#2499DB" : "#E06B6B",
          zIndex: 100,
          icon: DateHelper.getMapQuestImage(this.getMapPoiData[i]),
          //path: this.getPoiMapPath(this.getMapPoiData[i], false),
        };
        arr.push(locationMarker2);
      }
    }
    return arr;
  }

  getPoiMapPath(mapPoi: QuestMapPoi, isCity: boolean): any {
    var path: any[] = [];
    if (mapPoi.actionGoalRef !== undefined) {
      var results = mapPoi.actionGoalRef.filter(
        (x: ActionRefData) =>
          x.helperPath.includes("poiActiveAction") ||
          x.helperPath.includes("poiVisibilityAction")
      );
      for (var i = 0; i < results.length; i++) {
        var data = this.getMapPoiData.filter(
          (y: QuestMapPoi) => y.key == results[i].id
        )[0];
        if (isCity) {
          var val = this.getCityData.locations[data.loc.loc_uid];
          path.push({
            lat: val.lat_long.latitude,
            lng: val.lat_long.longitude,
          });
        } else {
          path.push({
            lat: data.loc.override_ll.latitude,
            lng: data.loc.override_ll.longitude,
          });
        }
      }
    }
    return path;
  }

  created(): void {
    this.$store.dispatch("mapPoiStore/getPoiType", this.gameData.gt_uid);
  }

  openAutoAssign(): void {
    this.showAutoAssign = true;
  }
  closeDialog(): void {
    this.showAutoAssign = false;
  }

  openLocation(key: string): void {
    this.openPoi(key);
  }

  handleTableSelection(rows: QuestMapPoi): void {
    this.openPoi(rows.key);
  }

  openPoi(key: string): void {
    this.$store.dispatch("mapPoiStore/getFxData", this.gameData);
    this.$store.dispatch("mapPoiStore/getInventoryData", this.gameData);
    this.mapPoiKey = key;
    this.showEditPoiPanel = true;
  }
  closeEditPoi(): void {
    this.showEditPoiPanel = false;
  }
}

export default ComposeMap;
